import React from 'react';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash/object';
import * as queryString from 'query-string';
import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@material-ui/core';
import {
    BodyTableCell,
    ContainerDiv,
    FlexBaselineDiv,
    FlexColumnDiv,
    FlexSpaceBetweenDiv,
    formatMainDescription,
    HeaderTableCell,
    OverflowXDiv,
    RightDiv,
    SectionTableCell
} from '../components/components';
import { EquipmentService } from './equipmentService';
import { CompanyService } from '../company/companyService';
import { EquipmentDialogButton } from './equipmentDialogButton';
import { DateTimeService } from '../utils/dateTimeService';
import PdfIcon from './images/icon-pdf-file.png';
import ExcelIcon from './images/icon-excel-file.png';
import { SortHeaderCell } from '../components/sortHeaderCell';
import { FilterDatePicker } from '../components/filterDatePicker';
import { TableFooterWithPaginator } from '../components/tableFooterWithPaginator';
import { InspectionTypeService } from '../inspectionType/inspectionTypeService';
import { CategoryService } from '../category/categoryService';
import { ProductService } from '../product/productService';
import { DateWithExpiration } from '../components/dateWithExpiration';
import TableCell from '@material-ui/core/TableCell';
import { CollectionViewUpdater } from '../utils/collectionViewUpdater';
import { StringService } from '../utils/stringService';
import Spinner from 'react-spinner-material';
import { PrimaryButton } from '../components/components';
import { Tooltip } from 'react-tippy';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import 'react-tippy/dist/tippy.css';
import moment from 'moment';
import { PageWrap, Card, CardHead, CardBody, PageBanner, CountBadge } from '../components/pageLayout';
import { Boxes } from 'lucide-react';

function calculateStatusColor(status) {
    switch (status) {
        case 'VALID': return 'transparent';
        case 'IMPROPER': return 'rgb(165, 35, 47)';
        case 'EXPIRED': return 'rgb(213, 117, 48)';
        case 'NA': return 'rgb(145, 145, 145)';
        default: throw new Error(`Unimplemented: ${status}`);
    }
}

class EquipmentsPage extends React.Component {
    constructor(props) {
        super(props);

        const { location } = props;
        const { view } = queryString.parse(location.search);

        this.collectionUpdater = CollectionViewUpdater.ofEquipments(this);
        this.reloadInitialData = this.reloadInitialData.bind(this);

        this.state = {
            isLoading: false,
            categories: [],
            inspectionTypes: [],
            products: [],
            companies: [],
            filterQuery: '',
            filterStatus: '',
            filterEnabledTagsOnly: true,
            filterCategoryId: '',
            filterInspectionTypeId: '',
            filterProductId: '',
            filterCompanyId: '',
            filterCreateFrom: null,
            filterCreateUpTo: null,
            filterLastInspectionFrom: null,
            filterLastInspectionUpTo: null,
            filterLastInspectionExpirationStatus: view === 'inspections-report' ? 'EXPIRED_OR_EXPIRING' : '',
            filterDueDateFrom: null,
            filterDueDateUpTo: null,
            filterDueDateExpirationStatus: '',
            collection: this.collectionUpdater.collection,
            clearedfilter: false,
            showAdditionalDateFilters: false,
            dataFabricacao: null,
            dataRecarga: null,
            dataUltimaPesagem: null
        };
    }

    reloadInitialData = async () => {
        this.setState({ isLoading: true });
        
        try {
            const [items, categories, inspectionTypes, products, companies] = await Promise.all([
                EquipmentService.summary(),
                CategoryService.list(),
                InspectionTypeService.list(),
                ProductService.list(),
                CompanyService.list()
            ]);
            
            this.collectionUpdater.initialData(items);
            
            this.setState({
                isLoading: false,
                categories,
                inspectionTypes,
                products,
                companies
            });
        } catch (error) {
            console.error("Error reloading data:", error);
            this.setState({ isLoading: false });
        }
    };

    clearFilters = async (event) => {
        event.preventDefault();
        
        await this.setState({
            filterQuery: '',
            filterStatus: '',
            filterEnabledTagsOnly: true,
            filterCategoryId: '',
            filterInspectionTypeId: '',
            filterProductId: '',
            filterCompanyId: '',
            filterCreateFrom: null,
            filterCreateUpTo: null,
            filterLastInspectionFrom: null,
            filterLastInspectionUpTo: null,
            filterLastInspectionExpirationStatus: '',
            filterDueDateFrom: null,
            filterDueDateUpTo: null,
            filterDueDateExpirationStatus: '',
            showAdditionalDateFilters: false,
            dataFabricacao: null,
            dataRecarga: null,
            dataUltimaPesagem: null
        });


        this.collectionUpdater.resetCollection();
        

        await this.reloadInitialData();
    };

    calculateQuery = () => {
        const {
            filterQuery: query,
            filterStatus: status,
            filterEnabledTagsOnly: enabledTagsOnly,
            filterCategoryId: categoryId,
            filterInspectionTypeId: inspectionTypeId,
            filterProductId: productId,
            filterCompanyId: companyId,
            filterCreateFrom: createFrom,
            filterCreateUpTo: createUpTo,
            filterLastInspectionFrom: lastInspectionFrom,
            filterLastInspectionUpTo: lastInspectionUpTo,
            filterLastInspectionExpirationStatus: lastInspectionExpirationStatus,
            filterDueDateFrom: dueDateFrom,
            filterDueDateUpTo: dueDateUpTo,
            filterDueDateExpirationStatus: dueDateExpirationStatus,
            collection
        } = this.state;
        const { field, direction } = collection.sorter;

        return {
            query,
            status,
            enabledTagsOnly,
            categoryId,
            inspectionTypeId,
            productId,
            companyId,
            createFrom: createFrom && createFrom.format('YYYY-MM-DD'),
            createUpTo: createUpTo && createUpTo.format('YYYY-MM-DD'),
            lastInspectionFrom: lastInspectionFrom && lastInspectionFrom.format('YYYY-MM-DD'),
            lastInspectionUpTo: lastInspectionUpTo && lastInspectionUpTo.format('YYYY-MM-DD'),
            lastInspectionExpirationStatus,
            dueDateFrom: dueDateFrom && dueDateFrom.format('YYYY-MM-DD'),
            dueDateUpTo: dueDateUpTo && dueDateUpTo.format('YYYY-MM-DD'),
            dueDateExpirationStatus,
            field,
            direction: field && direction
        };
    };

    componentDidMount() {
        this.setState({ isLoading: true });

        const { handleFilterChange } = this.collectionUpdater;
        const { clearedfilter } = this.state;

        let dataSearch = queryString.parse(this.props.location.search);

        if (clearedfilter === false) {
            function employeeSearch() {
                if (dataSearch.employeeData !== undefined) {
                    let employeeSelect = dataSearch.employeeData.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    return (
                        handleFilterChange({ filterQuery: employeeSelect.toLocaleLowerCase() })
                    );
                }
            }
            employeeSearch();

            function equipmentSearch() {
                if (dataSearch.categoryData !== undefined) {
                    var regExp = /\(([^)]+)\)/;
                    let skuValue = regExp.exec(dataSearch.categoryData);
                    let statusValueChart;
                    if (dataSearch.categoryDataStatus == 'Válidas') {
                        statusValueChart = 'VALID';
                    } else {
                        statusValueChart = 'IMPROPER';
                    }
                    return (
                        handleFilterChange({ filterQuery: skuValue[1].toLowerCase() })
                    );
                }
            }
            equipmentSearch();

            function doughnutSearch() {
                if (dataSearch.Doughnut !== undefined) {
                    let statusValue;
                    if (parseInt(dataSearch.Doughnut, 10) === 0) statusValue = 'EXPIRED';
                    if (parseInt(dataSearch.Doughnut, 10) === 1) statusValue = 'IMPROPER';
                    if (parseInt(dataSearch.Doughnut, 10) === 2) statusValue = 'VALID';
                    return (
                        handleFilterChange({ filterStatus: statusValue })
                    );
                }
            }
            doughnutSearch();

            // function histogramSearch() {
            //     let dateToFilter = new Date(Date.now());
            //     let convertedNum = 23 - parseInt(dataSearch.histogramData, 10);
            //     if (dataSearch.histogramData !== undefined) {
            //         dateToFilter.setMonth(dateToFilter.getMonth() - convertedNum);
            //         return (
            //             handleFilterChange({ filterLastInspectionFrom: moment(new Date(dateToFilter.getFullYear(), dateToFilter.getMonth(), 1)) }),
            //             handleFilterChange({ filterLastInspectionUpTo: moment(new Date(dateToFilter.getFullYear(), dateToFilter.getMonth() + 1, 0)) })
            //         );
            //     }
            // }
            // histogramSearch();
        }

        EquipmentService.summary().then(items => {
            this.collectionUpdater.initialData(items);
            this.setState({ isLoading: false });
        });

        CategoryService.list().then(categories => this.setState({ categories }));
        InspectionTypeService.list().then(inspectionTypes => this.setState({ inspectionTypes }));
        ProductService.list().then(products => this.setState({ products }));
        CompanyService.list().then(companies => this.setState({ companies }));
    }

    downloadPdf = () => EquipmentService.downloadPdf(this.calculateQuery());
    downloadExcel = () => EquipmentService.downloadExcel(this.calculateQuery());

    buildList = () => {
        const { isLoading, collection } = this.state;
        const { currentLanguage } = this.props;

        if (isLoading) {
            return (
                <TableRow>
                    <BodyTableCell colSpan={10}><Spinner size={50} spinnerColor="#2CA8FF" spinnerWidth={2} visible={true} /></BodyTableCell>
                </TableRow>
            );
        }

        const items = collection.paginator.pagedItems;

        if (items.length === 0) {
            return (
                <TableRow>
                    <BodyTableCell colSpan={10}>Lista vazia.</BodyTableCell>
                </TableRow>
            );
        }

        return items.map((equipment, index) => (
            <TableRow key={index} style={{ borderLeftStyle: 'solid', borderLeftWidth: '0.5rem', borderLeftColor: calculateStatusColor(equipment.status), opacity: equipment.enabledTag ? 1 : 0.5 }}>
                <BodyTableCell align='start'>{equipment.tagSerialNumber}</BodyTableCell>
                <BodyTableCell align='start'>{formatMainDescription(equipment.product.name, equipment.product.sku)}</BodyTableCell>
                <BodyTableCell align='start'>{formatMainDescription(equipment.extraLabel, equipment.extraCode)}</BodyTableCell>
                <BodyTableCell align='start'>{DateTimeService.formatDate(equipment.createdAt)}</BodyTableCell>
                <BodyTableCell align='start'>
                    <DateWithExpiration
                        date={equipment.dueDate}
                        daysToExpire={equipment.dueDateDaysToExpire}
                        expirationStatus={equipment.dueDateExpirationStatus} />
                </BodyTableCell>
                <BodyTableCell align='start'>{EquipmentService.formatExpirationStatus(equipment.dueDateExpirationStatus, currentLanguage)}</BodyTableCell>
                <BodyTableCell align='start'>
                    <DateWithExpiration
                        date={get(equipment, 'lastInspection.createdAt')}
                        daysToExpire={equipment.lastInspectionDaysToExpire}
                        expirationStatus={equipment.lastInspectionExpirationStatus} />
                </BodyTableCell>
                <BodyTableCell align='start'>{EquipmentService.formatExpirationStatus(equipment.lastInspectionExpirationStatus, currentLanguage)}</BodyTableCell>
                <BodyTableCell align='start'>{formatMainDescription(get(equipment, 'lastInspection.userName'), get(equipment, 'lastInspection.userEmail'))}</BodyTableCell>
                <BodyTableCell align='right'><EquipmentDialogButton equipment={equipment} currentLanguage={currentLanguage} /></BodyTableCell>
            </TableRow>
        ));
    };

    handleCategoryChange = (event) => {
        const categoryId = event.target.value;
        
        this.collectionUpdater.handleFilterChange({
            filterCategoryId: categoryId,
            filterInspectionTypeId: '', 
        });
        
        
        this.checkAdditionalFiltersCondition(categoryId, '');
    };

    handleInspectionTypeChange = (event) => {
        const inspectionTypeId = event.target.value;
        
        this.collectionUpdater.handleFilterChange({
            filterInspectionTypeId: inspectionTypeId,
        });
        
        
        this.checkAdditionalFiltersCondition(this.state.filterCategoryId, inspectionTypeId);
    };

    checkAdditionalFiltersCondition = (filterCategoryId, filterInspectionTypeId) => {
    const { categories, inspectionTypes } = this.state;

    const selectedCategory = categories.find(cat => cat.id === filterCategoryId);
    const selectedInspectionType = inspectionTypes.find(type => type.id === filterInspectionTypeId);

    if (
        selectedCategory && selectedCategory.name === 'COMBATE A INCÊNDIO' &&
        selectedInspectionType && selectedInspectionType.name === 'EXTINTORES'
    ) {
        this.setState({ showAdditionalDateFilters: true });
    } else {
        this.setState({ showAdditionalDateFilters: false });
    }
    };

    filterEquipmentsByAttributes = (equipments) => {
        const { dataFabricacao, dataRecarga, dataUltimaPesagem } = this.state;

        return equipments.filter(equipment => {
            const attributes = equipment.inspectionTypeAttribute || [];

            const fabricacaoMatch = !dataFabricacao || attributes.some(attr => 
                attr.attribute === "Data Fabricação" && this.compareDates(attr.value, dataFabricacao)
            );

            const recargaMatch = !dataRecarga || attributes.some(attr => 
                attr.attribute === "Data Recarga" && this.compareDates(attr.value, dataRecarga)
            );

            const pesagemMatch = !dataUltimaPesagem || attributes.some(attr => 
                attr.attribute === "Data Última Pesagem" && this.compareDates(attr.value, dataUltimaPesagem)
            );

            return fabricacaoMatch && recargaMatch && pesagemMatch;
        });
    };

    compareDates = (attributeDate, filterDate) => {
        if (!attributeDate || !filterDate) return true;
        const attributeDateObj = new Date(attributeDate);
        const filterDateObj = new Date(filterDate);
        return attributeDateObj.toDateString() === filterDateObj.toDateString();
    };

    updateCollectionWithFilters = () => {
        const { collection } = this.state;
        const filteredEquipments = this.filterEquipmentsByAttributes(collection.paginator.items);
        this.collectionUpdater.updateCollection({ ...collection, paginator: { ...collection.paginator, items: filteredEquipments } });
    };

    handleDateFilterChange = (filterName, value) => {
        this.setState({ [filterName]: value }, () => {
            this.updateCollectionWithFilters();
        });
    };

    render() {
        const {
            companies,
            collection,
            categories,
            inspectionTypes,
            products,
            filterQuery,
            filterStatus,
            filterCategoryId,
            filterInspectionTypeId,
            filterProductId,
            filterCompanyId,
            filterEnabledTagsOnly,
            filterCreateFrom,
            filterCreateUpTo,
            filterLastInspectionFrom,
            filterLastInspectionUpTo,
            filterLastInspectionExpirationStatus,
            filterDueDateFrom,
            filterDueDateUpTo,
            filterDueDateExpirationStatus,
            showAdditionalDateFilters,
            dataFabricacao,
            dataRecarga,
            dataUltimaPesagem
        } = this.state;

        const { currentLanguage } = this.props;
        const { updateCollection, handleFilterChange, handleSort } = this.collectionUpdater;

        const categoryInspectionTypes = inspectionTypes.filter(inspectionType => inspectionType.categoryId === filterCategoryId);
        const inspectionTypeProducts = products.filter(product => product.inspectionTypeId === filterInspectionTypeId);

        const fieldLabelStyle = { fontSize: '0.75rem', fontWeight: 600, color: '#334155', marginBottom: 4 };
        const dateCardStyle = { border: '1px solid #e2e8f0', borderRadius: 10, padding: 16, background: '#fff' };
        const dateCardTitleStyle = { fontWeight: 600, fontSize: '0.9rem', color: '#0f172a', marginBottom: 12 };

        return (
            <PageWrap>
                <PageBanner icon={Boxes} title={currentLanguage.equipments} />

                <Card>
                    <CardHead>Filtros</CardHead>
                    <CardBody>
                    {/* Buscar */}
                    <div style={{ marginBottom: 16 }}>
                        <div style={fieldLabelStyle}>{currentLanguage.search}</div>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            helperText={currentLanguage.tag_number + ", " + currentLanguage.equipment_sku + ", " + currentLanguage.equipment_information + " " + currentLanguage.or + " " + currentLanguage.inspected_by+ " " + currentLanguage.or + " " + currentLanguage.attribute}
                            value={filterQuery}
                            onChange={event => handleFilterChange({ filterQuery: StringService.normalize(event.target.value) })}
                        />
                    </div>

                    {/* ROW 1: dropdowns */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
                        <div>
                            <div style={fieldLabelStyle}>Status</div>
                            <FormControl fullWidth margin="dense">
                                <Select variant="outlined" displayEmpty value={filterStatus} onChange={event => handleFilterChange({ filterStatus: event.target.value })} inputProps={{ id: 'status-select' }}>
                                    <MenuItem value="">Selecione um status</MenuItem>
                                    <MenuItem value="NA">{currentLanguage.na.toUpperCase()}</MenuItem>
                                    <MenuItem value="VALID">{currentLanguage.valid.toUpperCase()}</MenuItem>
                                    <MenuItem value="EXPIRED">{currentLanguage.expired.toUpperCase()}</MenuItem>
                                    <MenuItem value="IMPROPER">{currentLanguage.improper.toUpperCase()}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div>
                            <div style={fieldLabelStyle}>{currentLanguage.category}</div>
                            <FormControl fullWidth margin="dense">
                                <Select variant="outlined" displayEmpty value={filterCategoryId} onChange={this.handleCategoryChange} inputProps={{ id: 'categoryId-select' }}>
                                    <MenuItem value="">Selecione uma categoria</MenuItem>
                                    {categories.map(category => (
                                        <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div>
                            <div style={fieldLabelStyle}>{currentLanguage.subcategories}</div>
                            <FormControl fullWidth margin="dense">
                                <Select variant="outlined" displayEmpty value={filterInspectionTypeId} onChange={this.handleInspectionTypeChange} inputProps={{ id: 'inspectionTypeId-select' }}>
                                    <MenuItem value="">Selecione uma subcategoria</MenuItem>
                                    {categoryInspectionTypes.map(inspectionType => (
                                        <MenuItem key={inspectionType.id} value={inspectionType.id}>{inspectionType.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div>
                            <div style={fieldLabelStyle}>{currentLanguage.product}</div>
                            <FormControl fullWidth margin="dense">
                                <Select variant="outlined" displayEmpty value={filterProductId} onChange={event => handleFilterChange({ filterProductId: event.target.value })} inputProps={{ id: 'productId-select' }}>
                                    <MenuItem value="">Selecione um produto</MenuItem>
                                    {inspectionTypeProducts.map(product => (
                                        <MenuItem key={product.id} value={product.id}>{product.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>

                    {/* Somente tags ativas */}
                    <FormControlLabel
                        style={{ marginTop: 8 }}
                        label={currentLanguage.active_tags_only}
                        control={
                            <Checkbox
                                checked={filterEnabledTagsOnly}
                                onChange={event => handleFilterChange({ filterEnabledTagsOnly: event.target.checked })}
                            />
                        }
                    />

                    {/* ROW 2: date filter cards */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 16, marginTop: 16 }}>
                        {/* Cadastro */}
                        <div style={dateCardStyle}>
                            <div style={dateCardTitleStyle}>{currentLanguage.register}</div>
                            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                <div style={{ flex: '1 1 120px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.from}</div>
                                    <FilterDatePicker disableFuture style={{ width: '100%' }} value={filterCreateFrom} onChange={date => handleFilterChange({ filterCreateFrom: date })} label="" />
                                </div>
                                <div style={{ flex: '1 1 120px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.to}</div>
                                    <FilterDatePicker disableFuture style={{ width: '100%' }} value={filterCreateUpTo} onChange={date => handleFilterChange({ filterCreateUpTo: date })} label="" />
                                </div>
                            </div>
                        </div>

                        {/* Última inspeção */}
                        <div style={dateCardStyle}>
                            <div style={dateCardTitleStyle}>{currentLanguage.last_inspection}</div>
                            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                <div style={{ flex: '1 1 100px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.from}</div>
                                    <FilterDatePicker disableFuture style={{ width: '100%' }} value={filterLastInspectionFrom} onChange={date => handleFilterChange({ filterLastInspectionFrom: date })} label="" />
                                </div>
                                <div style={{ flex: '1 1 100px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.to}</div>
                                    <FilterDatePicker disableFuture style={{ width: '100%' }} value={filterLastInspectionUpTo} onChange={date => handleFilterChange({ filterLastInspectionUpTo: date })} label="" />
                                </div>
                                <div style={{ flex: '1 1 120px' }}>
                                    <div style={fieldLabelStyle}>Status</div>
                                    <FormControl fullWidth margin="dense">
                                        <Select variant="outlined" displayEmpty value={filterLastInspectionExpirationStatus} onChange={event => handleFilterChange({ filterLastInspectionExpirationStatus: event.target.value })} inputProps={{ id: 'lastInspectionExpirationStatus-select' }}>
                                            <MenuItem value="">Selecione um status</MenuItem>
                                            <MenuItem value="NA">{currentLanguage.na.toUpperCase()}</MenuItem>
                                            <MenuItem value="VALID">{currentLanguage.valid.toUpperCase()}</MenuItem>
                                            <MenuItem value="EXPIRED">{currentLanguage.expired.toUpperCase()}</MenuItem>
                                            <MenuItem value="EXPIRING"> {currentLanguage.expiring} </MenuItem>
                                            <MenuItem value="EXPIRED_OR_EXPIRING">{currentLanguage.expired_or_expiring}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </div>

                        {/* Validade */}
                        <div style={dateCardStyle}>
                            <div style={dateCardTitleStyle}>{currentLanguage.due_date}</div>
                            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                <div style={{ flex: '1 1 100px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.from}</div>
                                    <FilterDatePicker style={{ width: '100%' }} value={filterDueDateFrom} onChange={date => handleFilterChange({ filterDueDateFrom: date })} label="" />
                                </div>
                                <div style={{ flex: '1 1 100px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.to}</div>
                                    <FilterDatePicker style={{ width: '100%' }} value={filterDueDateUpTo} onChange={date => handleFilterChange({ filterDueDateUpTo: date })} label="" />
                                </div>
                                <div style={{ flex: '1 1 120px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.status}</div>
                                    <FormControl fullWidth margin="dense">
                                        <Select variant="outlined" displayEmpty value={filterDueDateExpirationStatus} onChange={event => handleFilterChange({ filterDueDateExpirationStatus: event.target.value })} inputProps={{ id: 'dueDateExpirationStatus-select' }}>
                                            <MenuItem value="">Selecione um status</MenuItem>
                                            <MenuItem value="NA">{currentLanguage.na.toUpperCase()}</MenuItem>
                                            <MenuItem value="VALID">{currentLanguage.valid.toUpperCase()}</MenuItem>
                                            <MenuItem value="EXPIRED">{currentLanguage.expired.toUpperCase()}</MenuItem>
                                            <MenuItem value="EXPIRING">{currentLanguage.expiring}</MenuItem>
                                            <MenuItem value="EXPIRED_OR_EXPIRING">{currentLanguage.expired_or_expiring}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </div>

                        {showAdditionalDateFilters && (
                            <div style={dateCardStyle}>
                                <div style={dateCardTitleStyle}>Data de Fabricação</div>
                                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                    <TextField
                                        type="date"
                                        value={dataFabricacao}
                                        onChange={event => this.handleDateFilterChange('dataFabricacao', event.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        style={{ flex: '1 1 100px' }}
                                    />
                                </div>
                            </div>
                        )}
                        {showAdditionalDateFilters && (
                            <div style={dateCardStyle}>
                                <div style={dateCardTitleStyle}>Data de Recarga</div>
                                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                    <TextField
                                        type="date"
                                        value={dataRecarga}
                                        onChange={event => this.handleDateFilterChange('dataRecarga', event.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        style={{ flex: '1 1 100px' }}
                                    />
                                </div>
                            </div>
                        )}
                        {showAdditionalDateFilters && (
                            <div style={dateCardStyle}>
                                <div style={dateCardTitleStyle}>Data de Última Pesagem</div>
                                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                    <TextField
                                        type="date"
                                        value={dataUltimaPesagem}
                                        onChange={event => this.handleDateFilterChange('dataUltimaPesagem', event.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        style={{ flex: '1 1 100px' }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginTop: 16 }}>
                        <PrimaryButton onClick={event => this.clearFilters(event)}>{currentLanguage.clear_fields}</PrimaryButton>
                        <div>
                            <span>{currentLanguage.export}: </span>
                            <Button onClick={this.downloadPdf}><img src={PdfIcon} alt="pdf" />PDF</Button>
                            <Button onClick={this.downloadExcel}><img src={ExcelIcon} alt="excel" />XLSX</Button>
                        </div>
                    </div>
                    </CardBody>
                </Card>

                <Card>
                    <CardHead><Boxes size={18} color="#1CA5D9" /> {currentLanguage.equipments} <CountBadge>{collection.paginator.pagedItems.length}</CountBadge></CardHead>
                <OverflowXDiv>
                    <Table id="table-equipments">
                        <TableHead>
                            <TableRow>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="8%" field="tagSerialNumber">{currentLanguage.tag_number}</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="25%" field="product.name">{currentLanguage.equipment_sku}</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="10%" field="extraLabel">{currentLanguage.equipment_information}</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="10%" field="createdAt">{currentLanguage.register}</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="10%" field="dueDate"><span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Validade Equipamento
                                    <Tooltip
                                        title={currentLanguage.due_date_Tippy}
                                        arrow={true}
                                        arrowSize={'small'}
                                    ><InfoOutlinedIcon style={{ fontSize: "small" }} /></Tooltip></span></SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="5%" field="dueDateExpirationStatus">Status Validade Equipamento</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="10%" field="lastInspection.createdAt"><span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Última Inspeção
                                    <Tooltip
                                        title={currentLanguage.inspection_date_Tippy}
                                        arrow={true}
                                        arrowSize={'small'}
                                    ><InfoOutlinedIcon style={{ fontSize: "small" }} /></Tooltip></span></SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="5%" field="status">Status Inspeção</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="10%" field="lastInspection.userName">{currentLanguage.inspected_by}</SortHeaderCell>
                                <HeaderTableCell style={{ width: '5%' }} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.buildList()}
                        </TableBody>
                        <TableFooterWithPaginator collection={collection} onCollectionUpdate={updateCollection} colSpan={10} />
                    </Table>
                </OverflowXDiv>
                </Card>
            </PageWrap>
        );
    }
}

export default withRouter(EquipmentsPage);